import React, { Component } from "react";
import { Button, Form, Image } from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../config.json";
import "./Abha.css";
export default class Mobileabhaprofile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestId: sessionStorage.getItem("requestId"),
      // AbhaProfile: { mobile: "" },
      abhanumber: "",
      aadharNumber: "",
      isSubmitting: false,
      getAbhaQrCode: false,
      qrCodePaths: [],
      isSubmittingQrcode: false,
      updateprofile: false,
      mobileNumber: "",
      emailId: "",
      address: "",
      AbhaProfile: {},
      searchAccounts: [],
      selectedAbhaNumber: null,
    };
  }

  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
    }
  };

  componentDidMount() {
    this.ResponseHandler();
  }

  ResponseHandler = () => {
    const formData = new FormData();
    formData.append("requestId", this.state.requestId);

    fetch(configData.api_url + "C_Abhadetails/retriverequestId", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.detail) {
          const abhaRawData = data.detail.searchMobileData;
          const accountsData = data.detail.searchAccountsData;

          let basicList = [];
          let fullList = [];

          if (abhaRawData) {
            const parsed = JSON.parse(abhaRawData);
            basicList = parsed.ABHA || [];
          }

          if (accountsData) {
            const parsed = JSON.parse(accountsData);
            fullList = parsed.accounts || [];
          }
          let finalProfiles = [];

          if (basicList.length > 0) {
            // Merge logic only if both lists have data
            finalProfiles = basicList.map((basic) => {
              const match = fullList.find(
                (f) =>
                  f.name?.toLowerCase().trim() ===
                    basic.name?.toLowerCase().trim() &&
                  f.gender === basic.gender
              );
              return {
                ...basic,
                ...match,
                abhanumber: basic.ABHANumber,
              };
            });
          } else {
            // Use fullList directly if basicList is empty
            finalProfiles = fullList.map((profile) => ({
              ...profile,
              abhanumber: profile.ABHANumber,
            }));
          }
          this.setState({ abhaProfiles: finalProfiles });
        }
      })
      .catch((err) => {
        console.error("Fetch error:", err);
      });
  };

  HandleClick = () => {
    this.setState({ isSubmitting: true });
    var formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhadetails/retriveAbhacard", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message);
        if (data.status === "success") {
          this.handleDownloadPng(data.details);
        }
        this.setState({
          isSubmitting: false,
        });
      });
  };
  HandleQrcodeClick = () => {
    this.setState({ getAbhaQrCode: true });

    const formData = new FormData();
    formData.append("requestId", this.state.requestId);

    fetch(configData.api_url + "C_Abhadetails/getAbhaQrCode", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message);
        if (data.status === "success") {
          this.handleDownloadPng(data.details); // assuming this method handles showing or downloading the QR code
        }
        this.setState({ isSubmitting: false });
      })
      .catch((error) => {
        this.showToast("Something went wrong while fetching QR code.");
        this.setState({ isSubmitting: false });
      });
  };

  handleDownloadPng = (imageUrl) => {
    const filename = imageUrl.split("/").pop();
    const link = document.createElement("a");
    link.href = imageUrl;
    link.target = "_blank";
    link.download = filename; // Desired filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  handlenextClick = () => {
    window.location.href = "/abhaverification";
  };
  HandleABHAVerificationClick = () => {
    sessionStorage.setItem("abhanumber", this.state.AbhaProfile.abhanumber);
    window.location.href = "/abhaverification";
  };

  HandleUPClick = () => {
    window.location = "./updateprofile";
  };
  setSelectedProfile = (abhaNumber) => {
    const profile = this.state.abhaProfiles.find(
      (item) => item.ABHANumber === abhaNumber
    );

    if (!profile) return;

    const fullName = profile.name?.trim().split(" ") || [];

    const normalized = {
      ABHANumber: profile.ABHANumber,
      firstName: fullName[0] || "",
      middleName: fullName[1] || "",
      lastName: fullName.slice(2).join(" ") || "",
      dob: profile.dob || "",
      gender: profile.gender || "",
      mobileVerified: profile.mobileVerified || "",

      preferredAbhaAddress: profile.preferredAbhaAddress || "",

      abhaStatus: profile.status || profile.abhaStatus || "",
      photo: profile.profilePhoto || "",
    };

    this.setState({
      selectedAbhaNumber: abhaNumber,
      AbhaProfile: normalized,
    });
  };
  handleBackClick = () => {
    window.location = "./mobilenumberotp";
  };
  handleHomeClick = () => {
    window.location = "./";
  };
  render() {
    return (
      <div>
        <div className="row mb-2" id="flowStyle">
          <div className="col-md-3 flowTab Inactive">
            <div className="widget_BG widget_BG_grid bi bi-collection nav-icon">
              <p className="nav-label mt-2">Consent Collection</p>
            </div>
          </div>

          <div className="col-md-3 flowTab Inactive">
            <div className="widget_BG widget_BG_grid bi bi-file-richtext nav-icon">
              <p className="nav-label mt-2">Mobile Authentication</p>
            </div>
          </div>
          <div className="col-md-3 flowTab Inactive">
            <div className="widget_BG widget_BG_grid bi bi-file-person nav-icon">
              <p className="nav-label mt-2">ABHA Verfication</p>
            </div>
          </div>
          <div className="col-md-3 flowTab active-page">
            <div className="widget_BG widget_BG_grid bi bi-info-square nav-icon">
              <p className="nav-label mt-2">Profile Collection</p>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          {this.state.abhaProfiles?.map((item, index) => (
            <div
              className="col-md-4 card rounded-0 "
              key={index}
              style={{
                cursor: "pointer",
                border:
                  this.state.selectedAbhaNumber === item.ABHANumber
                    ? "2px solid #007bff"
                    : "1px solid #ccc",
              }}
              onClick={() => this.setSelectedProfile(item.ABHANumber)}
            >
              <div className="widget_BG widget_BG_grid p-3">
                <Form.Group className="mb-2">
                  <Form.Label>Name</Form.Label>
                  <Form.Control type="text" value={item.name} disabled />
                </Form.Group>
                <Form.Group className="mb-2">
                  <Form.Label>ABHA Number</Form.Label>
                  <Form.Control type="text" value={item.ABHANumber} disabled />
                </Form.Group>
                <Form.Group className="mb-2">
                  <Form.Label>Gender</Form.Label>
                  <Form.Control type="text" value={item.gender} disabled />
                </Form.Group>
              </div>
            </div>
          ))}
        </div>

        <Button
          variant="secondary"
          className="rounded-0 m-1"
          onClick={() =>
            this.setState({ selectedAbhaNumber: null, AbhaProfile: {} })
          }
        >
          Clear Selection
        </Button>
        <br />
        {this.state.selectedAbhaNumber && (
          <>
            <div className="row widget_BG widget_BG_grid d-flex m-0 mt-2">
              <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
                <Form.Group>
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="firstName"
                    id="firstName"
                    disabled
                    value={this.state.AbhaProfile.firstName}
                    className="form-control"
                  />
                </Form.Group>
              </div>
              <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
                <Form.Group>
                  <Form.Label>Middle Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="middleName"
                    id="middleName"
                    disabled
                    value={this.state.AbhaProfile.middleName}
                    className="form-control"
                  />
                </Form.Group>
              </div>
              <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
                <Form.Group>
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="lastName"
                    id="lastName"
                    disabled
                    value={this.state.AbhaProfile.lastName}
                    className="form-control"
                  />
                </Form.Group>
              </div>
              <div className="col-md-4 abhaprofilediv datepick">
                <Form.Group>
                  <Form.Label>Date Of Birth</Form.Label>

                  <div ClassName="custom-calendar">
                    <Form.Control
                      type="text"
                      name="dob"
                      id="dob"
                      value={this.state.AbhaProfile.dob}
                      disabled
                      className="form-control"
                    />
                  </div>
                </Form.Group>
              </div>
              <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
                <Form.Group controlId="policyType">
                  <Form.Label>Gender</Form.Label>
                  <Form.Control
                    as="select"
                    disabled
                    value={this.state.AbhaProfile.gender}
                    onChange={this.handlegenderchange}
                  >
                    <option value="">Select</option>
                    <option value="M">Male</option>
                    <option value="F">Female</option>
                    <option value="Tr">Transgender</option>
                  </Form.Control>
                </Form.Group>
              </div>

              <div className="col-md-4 abhaprofilediv datepick">
                <Form.Group>
                  <Form.Label>ABHA Number</Form.Label>

                  <div ClassName="custom-calendar">
                    <Form.Control
                      type="text"
                      name="abhanumber"
                      id="abhanumber"
                      value={this.state.AbhaProfile.ABHANumber}
                      disabled
                      className="form-control"
                    />
                  </div>
                </Form.Group>
              </div>
              <div className="col-md-4 abhaprofilediv datepick">
                <Form.Group>
                  <Form.Label>ABHA Address</Form.Label>

                  <div ClassName="custom-calendar">
                    <Form.Control
                      type="text"
                      name="preferredAbhaAddress"
                      id="preferredAbhaAddress"
                      value={this.state.AbhaProfile.preferredAbhaAddress}
                      disabled
                      className="form-control"
                    />
                  </div>
                </Form.Group>
              </div>
              <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
                <Form.Group>
                  <Form.Label>ABHA Status</Form.Label>

                  {this.state.AbhaProfile.abhaStatus === "ACTIVE" ? (
                    <i
                      className="bi bi-check"
                      style={{
                        color: "green",
                        fontSize: "50px",
                        marginLeft: "5px",
                      }}
                    ></i>
                  ) : this.state.AbhaProfile.abhaStatus === "INACTIVE" ? (
                    <i
                      className="bi bi-x"
                      style={{
                        color: "red",
                        fontSize: "1.2rem",
                        marginLeft: "5px",
                      }}
                    ></i>
                  ) : null}
                </Form.Group>
              </div>
              <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
                <Image
                  style={{
                    width: "100px",
                    marginLeft: "5px",
                    marginTop: "10px",
                  }}
                  src={"data:image/jpeg;base64," + this.state.AbhaProfile.photo}
                  alt="image"
                ></Image>
              </div>
            </div>
            <div className="row  widget_BG widget_BG_grid m-0 mt-2">
              <div className="col text-end">
                <Button onClick={this.handleBackClick}>Back</Button>
                <Button onClick={this.handleHomeClick}>Home Screen</Button>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}
